<template>
	<div id="modal-common-adjust-columns">
		<b-modal :id="modalName" hide-footer size="sm">
            <template v-slot:modal-title>
                Adjust Columns
            </template>

            <b-table-simple hover small caption-top bordered responsive>
                <b-tbody>
                    <b-tr v-for="field in fields" :key="field.key">
                        <b-td v-if="field.key != 'actions'">
                            <b-form-checkbox
                                :id="'checkbox-adjust-' + field.key"
                                :value="parseInt(1)"
                                v-model="field.visible"
                                :unchecked-value="parseInt(0)"
                            >
                            </b-form-checkbox>
                        </b-td>
                        <b-td v-if="field.key != 'actions'">
                            <span v-if="field.key == 'thumb'">Thumbnail</span>
                            <span v-else>{{ field.label }}</span>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>

            <b-button type="submit" variant="success" @click="adjustColumns">
                <span v-if="submitting">
                    <b-spinner small type="grow"></b-spinner>
                    Adjusting...
                </span>
                <span v-else>Update</span>
            </b-button>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [
            'fields'
		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-common-adjust-columns',
                submitting: 0
			}
		},

		methods: {
            adjustColumns() {
                this.fields.forEach(key => {
                    key.visible = parseInt(key.visible)
                })

                this.closeModal(this.modalName)
                this.showAlertBox('success', 'Columns Adjusted', 'Columns adjusted successfully!')
                this.$emit('saveColSaves', this.fields)
            }
		},

		computed: {

		},

		mounted() {
            // this.updatedFields = Object.assign({}, this.fields)
		}
	}
</script>
<style lang="scss">
    #modal-common-adjust-columns {
        .modal-dialog {
            width: 250px;
        }
    }
</style>
